<template>
  <div class="block py-24 sm:py-48">
    <div class="container xxl:px-24">
      <div class="mx-auto lg:w-2/3 lg:px-4">
        <div class="sm:flex text-center">
          <div
            v-for="block in component.blocks"
            :key="block.id"
            class="w-full mb-32 sm:px-8 sm:mb-0 md:px-32 lg:px-48 first:pl-0 last:pr-0"
          >
            <div class="text-4xl leading-4xl font-medium mb-8 text-green-75">
              {{ block.percentage }}
            </div>
            <span class="text-base">{{ block.content }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
  },
});
</script>
